import {
  Injectable,
  Injector,
  ComponentFactoryResolver,
  EmbeddedViewRef,
  ApplicationRef
} from '@angular/core';

@Injectable()
export class DomService {

  private childComponentRef: any;
  constructor(
    private componentFactoryResolver: ComponentFactoryResolver,
    private appRef: ApplicationRef,
    private injector: Injector
  ) { }

  public appendComponentTo(parentId: string, child: any, childConfig?: childConfig) {
    // 1. Create a component reference from the component 
    const childComponentRef = this.componentFactoryResolver
      .resolveComponentFactory(child)
      .create(this.injector);

    this.attachConfig(childConfig, childComponentRef);

    this.childComponentRef = childComponentRef;
    // 2. Attach component to the appRef so that it's inside the ng component tree
    this.appRef.attachView(childComponentRef.hostView);

    // 3. Get DOM element from component
    const childDomElem = (childComponentRef.hostView as EmbeddedViewRef<any>)
      .rootNodes[0] as HTMLElement;

    // 4. Append DOM element to the body
    document.getElementById(parentId).appendChild(childDomElem);

  }

  public removeComponent() {
    if (typeof this.childComponentRef !== 'undefined') {
      this.appRef.detachView(this.childComponentRef.hostView);
      this.childComponentRef.destroy();
    }
  }


  private attachConfig(config, componentRef) {
    let inputs = config.inputs;
    for (var key in inputs) {
      componentRef.instance[key] = inputs[key];
    }
    // componentRef.instance.myInput = 'asd';
  }
}
interface childConfig {
  inputs: object,
  outputs: object
}


// WEBPACK FOOTER //
// C:/Users/beyn/Documents/GitLab/spinmatic-casino/src/app/Modules/Shared/services/dom.service.ts